// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".patent-view__side-function-task{padding:16px;border-top:1px solid #ebecf0;text-align:center}.patent-view__side-function-task .pt-ui-btn{padding:3px 15px;width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
